module.exports = __webpack_public_path__ + "img/3-tr.76815c4e.jpg";